import {
    Menu,
    MenuItem,
    SxProps,
    ToggleButton,
    ToggleButtonGroup
  } from '@mui/material';
  import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
  import { CSSProperties, useState } from 'react';
  import React from 'react';
  
const disableOpacity = 0.6;
export interface ButtonMenuItem {
    component: React.ReactNode,
    value: string;
}
export interface ButtonMenuItemProps {
    id: string;
    title: string;
    buttonSxStyles?: SxProps;
    arrowSxProps?: SxProps;
    onClickOption: (option: ButtonMenuItem) => void;
    menuOptions: Array<ButtonMenuItem>;
    disabled?: boolean;
  }
export const MenuButton = ({
    id,
    buttonSxStyles,
    title,
    arrowSxProps,
    onClickOption,
    menuOptions,
    disabled = false
  }: ButtonMenuItemProps ) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
  
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      if (!disabled) {
        setAnchorEl(event.currentTarget);
      }
    };
  
    const handleClose = (value: any) => {
      setAnchorEl(null);
      if (onClickOption) {
        onClickOption(value);
      }
    };
  
    const internalButtonSxStyles: SxProps = {
      backgroundColor: '#FF9E00',
      height: '42px', 
      color: 'black', 
      width: '120px', 
      '&:hover': { backgroundColor: '#FF9E00' },   
      ...buttonSxStyles,
      opacity: disabled ? disableOpacity : 1,
    }
   
    const internalArrowSxStyles: SxProps = {
      backgroundColor: '#E99102',
      height: '42px',
      '&:hover': { backgroundColor: '#FF9E00' },
      ...arrowSxProps
    }
    return (
      <>
        <ToggleButtonGroup
          id={id}
          exclusive
          onClick={handleClick}
          disabled={disabled}
        >
          <ToggleButton id={`${id}-1`} sx={internalButtonSxStyles} value={'1'}>
            {title}
          </ToggleButton>
          <ToggleButton
            id={`${id}-2`}
            value={'2'}
            sx={internalArrowSxStyles}
          >
            <ArrowDropDownIcon htmlColor="black" />
          </ToggleButton>
        </ToggleButtonGroup>
        <Menu
          MenuListProps={{
            'aria-labelledby': 'customized-button'
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          {menuOptions.map((option: ButtonMenuItem) => {
            const { component, value } = option;
            return (
              <MenuItem
                id={`${value}`}
                key={`menu-item-${value}`}
                onClick={() => handleClose(option.value)}
              >
                {component}
              </MenuItem>
            );
          })}
        </Menu>
      </>
    );
  };

  